module.exports = __webpack_public_path__ + "static/media/icon_bus_default_selected.42099543.png";